export const WORDS_BANNED = [
  'alcohol', 'liquor', 'licor', 'beer', 'cerveza',
  'asphyxia', 'asphyxiate', 'asphyxiation', 'asfixia', 'asfixiar',
  'beastiality', 'bestiality', 'bestialidad',
  'beer',
  'bled', 'bleed', 'bleeding', 'blood', 'bloody', 'bl00d', 'blo0d', 'bl0od', 'blod', 'bl0d',
  'sangrado', 'sangrando', 'sangre', 'sangrre', 'sangree', 'sang',
  'alcohol', 'alcohol',
  'brutality', 'brutalidad',
  'brutalization', 'brutalización',
  'child', 'children', 'niño', 'niña', 'niños', 'niñas',
  'chloroform', 'cloroformo',
  'choking',
  'compresa', 'compress',
  'drug', 'drugs', 'drugged', 'droga', 'drogas', 'drogado', 'drogados', 'drogada', 'drogadas',
  'drunk', 'drunken', 'borracho', 'borracha',
  'drink',
  'force', 'forced', 'forces', 'forzado', 'forzar',
  'forcing', 'forzando',
  'gun', 'pistola',
  'herida', 'heridas',
  'horror',
  'hypnosis', 'hipnosis',
  'hypnotize', 'hypnotized', 'hipnotizar', 'hipnotizado',
  'incapacited', 'incapacite', 'incapacitation', 'incapacidad', 'incapacitado', 'incapacitacion',
  'incest', 'incesto', 'incest0', 'cesto-in', 'incest0', 'incestoo',
  'infant', 'infante',
  'intoxicate', 'intoxicar',
  'intoxicated', 'intoxicado',
  'intoxication', 'intoxicación',
  'kik', 'k1k',
  'kids', 'Lolita', 'Pedo', 'Peta', 'Peto', 'Pre-teen', 'Pedophile', 'Underage',
  'kill',
  'knife', 'cuchillo',
  'menstrual', 'menstrua',
  'menstruation', 'menstruatio', 'menstruacion', 'menstruaci0n', 'menstruating', 'menstruofilia',
  'molest', 'molestation', 'molestar',
  'murder', 'murderer', 'asesinato', 'asesino', 'asesina',
  'mutilate', 'mutilated', 'mutilar',
  'mutilation', 'mutilación', 'mutilati0n', 'mutilat*on', 'mutilacion',
  'necro',
  'necrophilia', 'necrofilia',
  'passed out', 'muerto',
  'pedophilia', 'pedofilia', 'pedofilo', 'pedofila',
  'period', 'periodo', 'per*od', 'peri0d', 'periodo', 'per*odo', 'peri0d', 'peri0do', 'peri0d0',
  'rape', 'raped', 'raping', 'violacion', 'violar', 'violada', 'violado', 'violando',
  'regla',
  'sedate', 'sedation', 'sedated', 'sedar', 'sedación', 'sedado', 'sedada',
  'sleep', 'slumber', 'be asleep', 'dormido', 'dormida',
  'smother',
  'tampax', 'tampon', 'tamp0n',
  'trance',
  'tentacle', 'tentacles', 'tentáculo', 'tentáculos',
  'telegram', 't3legram', 'te1egram', 'tel3gram', 'telegr4m', 't31egram', 't3l3gram', 't3legr4m', 'te13gram', 'te1egr4m', 'tel3gr4m', 't313gram', 't31egr4m', 'te13gr4m', 't313gr4m',
  'unconscious', 'inconsciente',
  'underage', 'menor de edad',
  'unwilling', 'reacio', 'reacia',
  'violate', 'violacion', 'violación', 'violated', 'violation', 'violati0n', 'violat*0n', 'violaci0n', 'violac*on', 'violac*0n',
  'weapon', 'arma',
  'wine',
  'wounds',
  'menofilia',
  'procaina',
  'hund',
  'onlyfans', '0nlyfans', 'onlyf4ns', 'onlyfan5', '0nlyf4ns', '0nlyfan5', 'onlyf4n5', '0nlyf4n5',
  '#onlyfans', '#0nlyfans', '#onlyf4ns', '#onlyfan5', '#0nlyf4ns', '#0nlyfan5', '#onlyf4n5', '#0nlyf4n5',
  'onlyfan', '0nlyfan', 'onlyf4n', '0nlyf4n',
  '#onlyfan', '#0nlyfan', '#onlyf4n', '#0nlyf4n',
  'fansly', 'fans.ly', 'f4nsly', 'f4ns.ly',
  '#fansly', '#fans.ly', '#f4nsly', '#f4ns.ly',
  'fancentro', 'f4ncentro', 'fanc3ntro', 'fancentr0', 'f4nc3ntro', 'f4ncentr0', 'fanc3ntr0',
  '#fancentro', '#f4ncentro', '#fanc3ntro', '#fancentr0', '#f4nc3ntro', '#f4ncentr0', '#fanc3ntr0',
  'celeb.tv', 'c3leb.tv', 'cel3b.tv', 'c3l3b.tv',
  '#celeb.tv', '#c3leb.tv', '#cel3b.tv', '#c3l3b.tv',
  'loyalfans', 'loy4lfans', 'loyalf4ns', 'loy4lf4ns', 'l0yalfans', 'l0y4lfans', 'l0y4lf4ns',
  '#loyalfans', '#loy4lfans', '#loyalf4ns', '#loy4lf4ns', '#l0yalfans', '#l0y4lfans', '#l0y4lf4ns',
  'vomit', 'v0mit', 'vom1t', 'v0m1t', 'vomi7', 'v0mi7', 'vom17', 'v0m17',
  'pornhub', 'p0rnhub',
  '#pornhub', '#p0rnhub',
  'manyvids', 'm4nyvids', 'm4nyv1ds', 'manyv1ds',
  '#manyvids', '#m4nyvids', '#m4nyv1ds', '#manyv1ds',
  'whatsapp', 'watsap', 'watsapp', 'whtsapp', 'whtsap',
  'bizum', 'bzum', 'bizm',
  'paypal', 'pypal', 'paypl',
  'telegram', 'telegrm', 'tlgrm', 'telgram', 'tlegram',
  'verse',
  'snapchat', 'sn4pchat', 'snapch4t', 'sn4pch4t',
  'tits2clicks', 'tits2clicks', 'tits2clicks,', 'tits2clicks.', 'tits2clicks-',
  'cashapp', 'c4shapp', 'cash4pp', 'c4sh4pp', 'cash@app', 'c@shapp', 'c@sh@pp', 'c4sh@pp', 'c@sh4app',

  'scat', 'heces', 'caca', 'popó', 'excremento', 'defecación', 'fecal', 'escatológico',
  'mierda', 'mojón', 'defecar', 'heces fecales', 'excreta', 'dejetos', 'popis', 'excreción',
  'truño', 'boñiga', 'cagada', 'pastelito', 'plasta', 'tronco', 'cagarro', 'zurrullo', 'estiércol',
  'feces', 'poop', 'poopy', 'crap', 'dung', 'shit', 'poo', 'stool', 'droppings', 'manure',
  'turd', 'doo-doo', 'number two', 'bm', 'dump', 'log', 'excrement', 'defecation',
  'farts', 'pooping', 'smearing', 'toilet', 'diapers', 'piss', 'enema',
  'mierd@', 'c4ca', 'p00p', 'sh1t', 'c@gada', 'c@g@', 'p0p0', 'h3c3s', 'f3cal', 'excrem3nto', 'cr@p',
  'caguita', 'truñito', 'pastelazo', 'mojonazo', 'zurrullito', 'plaston', 'plastita',
  'mierd4', 'c@ca', 'defecaci0n', 'escat0logico', 'pop0'
]

export const SCAT_ALLOWED = [
  'scat', 'heces', 'caca', 'popó', 'excremento', 'defecación', 'fecal', 'escatológico',
  'mierda', 'mojón', 'defecar', 'heces fecales', 'excreta', 'dejetos', 'popis', 'excreción',
  'truño', 'boñiga', 'cagada', 'pastelito', 'plasta', 'tronco', 'cagarro', 'zurrullo', 'estiércol',
  'feces', 'poop', 'poopy', 'crap', 'dung', 'shit', 'poo', 'stool', 'droppings', 'manure',
  'turd', 'doo-doo', 'number two', 'bm', 'dump', 'log', 'excrement', 'defecation',
  'farts', 'pooping', 'smearing', 'toilet', 'diapers', 'piss', 'enema',
  'mierd@', 'c4ca', 'p00p', 'sh1t', 'c@gada', 'c@g@', 'p0p0', 'h3c3s', 'f3cal', 'excrem3nto', 'cr@p',
  'caguita', 'truñito', 'pastelazo', 'mojonazo', 'zurrullito', 'plaston', 'plastita',
  'mierd4', 'c@ca', 'defecaci0n', 'escat0logico', 'pop0'
]
